import styled from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

export const StyledSportsContainer = styled.section`
  padding: 0;
  background-color: ${themeStyles.colors.black.main};
  min-height: 100vh;
  ${themeMedia.desktop`
    padding: 1rem;
  `};
`
